<app-lazy-loading *transloco="let t" [show]="isLoaded">
  <ng-container>
    <section attr.aria-label="{{t('section.current-edition.aria-label')}}" *ngIf="issue" class="card ap-default-card mb-3">
      <div class="card-header">
        <div class="header-content">{{ t('section.current-edition.name') }}</div>
      </div>
      <div class="card-body  pt-4">
        <div class="app-issue-panel clearfix">
          <app-issue-template [issue]="issue"></app-issue-template>
        </div>
        <div class="float-end pb-3 clearfix"><a routerLink="/issues" attr.aria-label="{{t('alternate.link-issue-all')}}" title="{{t('alternate.link-issue-all')}}">{{ t("btn.all-issues") }} <i class="bi bi-chevron-double-right"></i></a></div>
      </div>
    </section>
  </ng-container>
  <ng-container placeholder>
    <section attr.aria-label="{{t('section.featured-article.aria-label')}}" class="card ap-default-card mb-3">
      <div class="card-header">
        <div class="placeholder w-25">{{ t('section.featured-article.name') }}</div>
      </div>
      <div class="card-body w-100">
        <div *ngFor="let number of [0,1,2]" class="item item-placeholder w-100 clearfix">
          <span class="title placeholder mt-1 w-25">&nbsp;</span>
          <span class="date placeholder mt-1 w-100">&nbsp;</span>
          <div class="right placeholder mt-1 clearfix w-25">&nbsp;</div>
          <div class="right placeholder mt-1 clearfix w-25">&nbsp;</div>
        </div>
      </div>
    </section>
  </ng-container>
</app-lazy-loading>
